import { useState, type ComponentProps } from "react";
import { onColorSchemeChange, readColorScheme } from "../lib/colorScheme";
import { themedSvgSources, type ThemedSvgSources } from "../lib/themedSvg";

type Props = Omit<ComponentProps<"img">, "ref" | "src"> & { src: string };

export function ConnectorImage({ src, ...props }: Props) {
  const sources = themedSvgSources(src);
  return sources ? (
    <ThemedConnectorImage {...props} sources={sources} />
  ) : (
    <img {...props} src={src} />
  );
}

function ThemedConnectorImage({
  sources,
  ...props
}: Omit<Props, "src"> & { sources: ThemedSvgSources }) {
  const [scheme, setScheme] = useState(readColorScheme);

  const observeScheme = (image: HTMLImageElement) => {
    const update = () => {
      setScheme(readColorScheme(image));
    };
    update();
    return onColorSchemeChange(update);
  };

  return <img {...props} src={sources[scheme]} ref={observeScheme} />;
}
